module.exports = __webpack_public_path__ + "img/platform_icon_2.46698f38.png";